// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"265":"1a1e3b99cdb446ce","432":"72b89e3d26ead0ca","466":"f9ddcedbedcf1de2","641":"dbec547938f62ef4","959":"ba2e268621f72ed3","976":"d7426db295939328","979":"d806ee5bcae4a45c"}[chunkId] + "-fed.js";
};